import React from 'react';

const Benchmarking = () => {
  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h3 className="text-lg font-medium mb-3">Benchmarking (Anonymous Comparison)</h3>
      
      <div className="mb-2">
        <p className="mb-1">Your practice vs similar oncology groups</p>
        <div className="relative h-20 bg-blue-100 rounded">
          {/* Points on the chart */}
          <div className="absolute w-2 h-2 bg-black rounded-full" style={{top: '30%', left: '20%'}}></div>
          <div className="absolute w-2 h-2 bg-black rounded-full" style={{top: '40%', left: '40%'}}></div>
          <div className="absolute w-2 h-2 bg-black rounded-full" style={{top: '50%', left: '60%'}}></div>
          <div className="absolute w-2 h-2 bg-black rounded-full" style={{top: '60%', left: '80%'}}></div>
        </div>
      </div>
      
      <div className="flex justify-between text-sm">
        <div>
          <span className="font-medium">Above average:</span>
          <span className="block text-green-500">Documentation efficiency</span>
        </div>
        
        <div className="text-right">
          <span className="font-medium">Below average:</span>
          <span className="block text-red-500">Patient wait times</span>
        </div>
      </div>
    </div>
  );
};

export default Benchmarking;